/* Confirmations report options */
import {helpers} from '@/ft-vue-core'

const {displayTime, displayDateTime} = helpers

export default {
  computed: {
    groupingOptions () {
      return [
        {
          id: 1,
          name: 'Location',
          group: [
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total',
              caption: (row, rowIndex, rows) => {return row.locationName}
            }
          ]
        },
        {
          id: 2,
          name: 'Reservation Time',
          group: [
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total',
              caption: (row, rowIndex, rows) => {
                return displayDateTime(row.dateTime)
              }
            }
          ]
        },
        {
          id: 3,
          name: 'Location & Time',
          group: [
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total'
            },
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total',
              caption: (row, rowIndex, rows) => {
                return row.locationName + ' - ' + displayDateTime(row.dateTime) + ' (' + row.eventName + ')'
              }
            }
          ],
          fields: ['eventName']
        },
        {
          id: 5,
          name: 'Location, Time & Reservation',
          group: [
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total'
            },
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total',
              caption: (row, rowIndex, rows) => {
                return row.locationName + ' - ' + displayDateTime(row.dateTime) + ' (' + row.eventName + ')'
              }
            },
            {
              by: ['reservationId', 'ASC'],
              thinAggregate: true,
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => '#' + row.reservationId + ' Total'
            }
          ],
          fields: ['eventName']
        },
        {
          id: 4,
          name: 'Time & Location',
          group: [
            {
              by: ['dateTime', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => displayTime(row.dateTime) + ' Total'
            },
            {
              by: ['locationName', 'ASC'],
              showAggregates: true,
              aggregateLabel: (row, rowIndex, rows) => row.locationName + ' Total',
              caption: (row, rowIndex, rows) => {
                return displayDateTime(row.dateTime) + ' (' + row.eventName + ')' + ' - ' + row.locationName
              }
            }
          ],
          fields: ['eventName']
        }
      ]
    },
    columnOptions () {
      return this.baseColumnOptions.filter(c => ![18].includes(c.id)) // Exclude meal period name column
    }
  }
}
